import {
  SET_ASSET_TYPE,
  RESET_ASSET_TYPE,
} from './types/AssetTypesActionTypes';

export function setAssetTypeSelectionActionCreator(type) {
  return {
    type: SET_ASSET_TYPE,
    payload: {
      appContext: type,
    },
  };
}

export function resetAssetTypeSelectionActionCreator() {
  return {
    type: RESET_ASSET_TYPE,
    payload: {
      appContext: null,
    },
  };
}
